export default {"src":"/_next/static/media/zoom-in.01b2b130.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};